/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Faq_Q5_QuestionInputs */

const en_home_faq_q5_question = /** @type {(inputs: Home_Faq_Q5_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where do I find emergency assistance information?`)
};

const fr_home_faq_q5_question = /** @type {(inputs: Home_Faq_Q5_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Où trouver les informations d'assistance d'urgence ?`)
};

/**
* | output |
* | --- |
* | "Where do I find emergency assistance information?" |
*
* @param {Home_Faq_Q5_QuestionInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_faq_q5_question = /** @type {((inputs?: Home_Faq_Q5_QuestionInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Faq_Q5_QuestionInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_faq_q5_question(inputs)
	return fr_home_faq_q5_question(inputs)
});